export const PortOrientation = {
  NORTH: "North",
  EAST: "East",
  SOUTH: "South",
  WEST: "West"
};
